export const naokoLines = {
  ramen: {
    lines: [
      { speaker: "Naoko", text: "Flicker from my past—\na sword my father once held.\nShe sold it for spite." },
      { speaker: "Randy", text: "My ex sold my hat.\nNot a sword, but it still hurt.\nIt had my sweat stains." },

      { speaker: "Naoko", text: "Lips like kindling sparks,\nbut passion burned through too fast.\nNow I serve the coals." },
      { speaker: "Randy", text: "My lips sparked once too.\nChili ramen. Bad idea.\nStill, no regrets. Slurp." },

      { speaker: "Naoko", text: "He wore red for me.\nThen left my heart in embers.\nStill—I pour, I burn." },
      { speaker: "Randy", text: "I wear red for you.\nMostly ‘cause all my shirts match\ntropical regret." },

      { speaker: "Naoko", text: "Some fires stay buried—\nsheathed beneath a lover’s spite.\nBut still—I feel heat." },
      { speaker: "Randy", text: "Same. My ex kept pics—\nposted them with fire emojis.\nStill burns. Still hot, though." }
    ],
    voices: [
      "naoko_ramen1",
      "naoko_ramen2",
      "naoko_ramen3",
      "naoko_ramen4"
    ],
    randyVoices: [
      "randy_naoko1",
      "randy_naoko2",
      "randy_naoko3",
      "randy_naoko4"
    ]
  }
};

export default naokoLines;
